import { lazy } from 'react';
import { authModules } from 'app/auth';
import ABSUtils from '@abs/utils/ABSUtils';
import themesConfig from 'app/configs/themesConfig';

const Overview = lazy(() => import('./Overview'));

const OverviewConfig = {
	settings: {
		layout: {
			config: {}
		},
		theme: {
			main: ABSUtils.IsDarkMode() ? themesConfig.inventuriusDark : themesConfig.inventurius,
			navbar: ABSUtils.IsDarkMode() ? themesConfig.inventuriusDark : themesConfig.inventurius,
		}
	},
	routes: [
		{
			path: '/iv/overview',
			element: <Overview />,
			auth: authModules.iv_default
		}
	]
};

export default OverviewConfig;
